import React from 'react';

const SvgLs = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="LS_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="LS_svg__b" fill="#fff">
        <use xlinkHref="#LS_svg__a" />
      </mask>
      <rect
        stroke="#F5F5F5"
        strokeWidth={0.5}
        x={0.25}
        y={0.25}
        width={27.5}
        height={19.5}
        rx={2}
      />
      <path fill="#0C33B8" mask="url(#LS_svg__b)" d="M0 0h28v6.667H0z" />
      <path fill="#1DB158" mask="url(#LS_svg__b)" d="M0 13.333h28V20H0z" />
      <path
        d="M13.333 10l.456-1.367c.117-.35.304-.355.422 0L14.667 10l1.148 1.722c.102.153.075.37-.073.474 0 0-.409.47-1.742.47s-1.742-.47-1.742-.47a.361.361 0 0 1-.073-.474L13.333 10z"
        fill="#262626"
        mask="url(#LS_svg__b)"
      />
      <circle
        stroke="#262626"
        strokeWidth={0.667}
        mask="url(#LS_svg__b)"
        cx={14}
        cy={8.667}
        r={1}
      />
    </g>
  </svg>
);

export default SvgLs;
